<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="科目">
          <el-input size="mini" v-model="params.Subject" placeholder="请填写科目" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SubjectNumber" label="序号" :width="isMB?60:80" align="center" />
        <el-table-column prop="Subject" label="科目" />
        <el-table-column prop="CreateTime" label="创建时间" :min-width="isMB?100:''">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ed/subject").default,
      isMB: this.$store.state.isMB,
      params: {
        Subject: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>